import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path1/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "gutenberg-blocks"
    }}>{`Gutenberg Blocks`}</h2>
    <p><inlineCode parentName="p">{`Cartsy`}</inlineCode>{` theme is build on `}<inlineCode parentName="p">{`Gutenberg Blocks`}</inlineCode>{`. In our theme we have provided few native gutenberg blocks using those blocks we have configured our theme pages. You can also use those blocks to add them to any pages or blogs. Below image shows all the gutenberg blocks our theme offers.`}</p>
    <p><img alt="13. Cartsy Block.png" src="https://res.cloudinary.com/redq-inc/image/upload/v1595965542/cartsy_doc/gutenberg_g2kvpa.png" /></p>
    <p>{`You can use any one of these blocks. Just hover over the block and you can see its preview with a description of what this block represents.`}</p>
    <h2 {...{
      "id": "cartsy-layout"
    }}>{`Cartsy Layout`}</h2>
    <p>{`We add some `}<inlineCode parentName="p">{`generic layout`}</inlineCode>{` page on the Gutenberg page.`}</p>
    <p><img alt="layout_sarn1c.png" src="https://res.cloudinary.com/redq-inc/image/upload/v1595967168/cartsy_doc/layout_sarn1c.png" /></p>
    <p>{`More layout will be coming in the future.`}</p>
    <h2 {...{
      "id": "product-layout"
    }}>{`Product Layout`}</h2>
    <p>{`We've several product layouts, and you can build a custom product page using those gutenberg layouts. To create a custom layout at first go to a new page`}</p>
    <p><img alt="29. Create new Page.png" src="https://res.cloudinary.com/redq-inc/image/upload/v1595965595/cartsy_doc/Create_Layout_Page_cpnllr.png" /></p>
    <p>{`Then,`}</p>
    <ol>
      <li parentName="ol">{`Input the page title`}</li>
      <li parentName="ol">{`Click plus button for search Gutenberg block`}</li>
      <li parentName="ol">{`Search layout from Gutenberg search block`}</li>
      <li parentName="ol">{`click layout`}</li>
    </ol>
    <p><img alt="30. New Layout.png" src="https://res.cloudinary.com/redq-inc/image/upload/v1595965659/cartsy_doc/layout_g2cyet.png" /></p>
    <p>{`After click `}<inlineCode parentName="p">{`layout`}</inlineCode>{` a pre-defined layout will be setup.`}</p>
    <p><img alt="imported_layout_cbxu2o.png" src="https://res.cloudinary.com/redq-inc/image/upload/v1595965731/cartsy_doc/imported_layout_cbxu2o.png" /></p>
    <p>{`If you want to disable sidebar, then disable sidebar from Layout settings otherwise select sidebar style.`}</p>
    <p><img alt="31. Layout Style.png" src="https://res.cloudinary.com/redq-inc/image/upload/v1595965814/cartsy_doc/sidebar_cv8rq5.png" /></p>
    <p>{`From the banner, you can upload a banner image. Also, you can disable the search option from the banner.`}</p>
    <p><img alt="banner_qjrqgz.png" src="https://res.cloudinary.com/redq-inc/image/upload/v1595965956/cartsy_doc/banner_qjrqgz.png" /></p>
    <p>{`We already some product layout and will be adding lots of layout designs in the future. From product section settings, you can change the product layout style.`}</p>
    <p><img alt="39. Product Layout Variation.png" src="https://res.cloudinary.com/redq-inc/image/upload/v1595966037/cartsy_doc/product_style_icsakr.png" /></p>
    <p>{`After building the product layout, change the page template to `}<inlineCode parentName="p">{`Cartsy Full With Template`}</inlineCode>{` and publish the page.`}</p>
    <p><img alt="40. Change template.png" src="https://res.cloudinary.com/redq-inc/image/upload/v1595966082/cartsy_doc/home_algolia_trdujd.png" /></p>
    <h2 {...{
      "id": "change-default-product-page"
    }}>{`Change Default Product Page`}</h2>
    <p>{`To change the default home page to newly created custom product layout page, create an empty `}<inlineCode parentName="p">{`blog page`}</inlineCode>{` and go to the `}<inlineCode parentName="p">{`Settings -> Reading -> Change homepage display to static`}</inlineCode></p>
    <p><img alt="43. Publish Page.png" src="https://res.cloudinary.com/redq-inc/image/upload/v1595966172/cartsy_doc/blog_page_v9fhih.png" /></p>
    <p><img alt="44. Change product home page.png" src="https://res.cloudinary.com/redq-inc/image/upload/v1595966228/cartsy_doc/home_page_sru6ag.png" /></p>
    <h2 {...{
      "id": "shop-page-layout"
    }}>{`Shop Page Layout`}</h2>
    <p>{`To change the shop page layout,`}</p>
    <ol>
      <li parentName="ol">{`Go to the `}<inlineCode parentName="li">{`shop page.`}</inlineCode></li>
      <li parentName="ol">{`Click the `}<inlineCode parentName="li">{`customize`}</inlineCode>{` button from the top bar`}</li>
      <li parentName="ol">{`then go to `}<inlineCode parentName="li">{`Cartsy Theme Panel -> WC_General Settings`}</inlineCode>{` and change the `}<inlineCode parentName="li">{`WooCommerce grid.`}</inlineCode></li>
    </ol>
    <p><img alt="WooCommerce_Grid_readcg.png" src="https://res.cloudinary.com/redq-inc/image/upload/v1596018934/cartsy_doc/WooCommerce_Grid_readcg.png" /></p>
    <h3 {...{
      "id": "alternative-banner--slider-images"
    }}>{`Alternative banner & slider images`}</h3>
    <p>{`We add an option to use different images or different size images for Slider, banner, and RnB banner. To use different photos,`}</p>
    <p>{`Click on the Slider or banner and enable`}</p>
    <pre><code parentName="pre" {...{}}>{`Show another slider on mobile.
`}</code></pre>
    <p><img alt="DifferentSlider.jpg" src="https://res.cloudinary.com/redq-inc/image/upload/v1611391163/cartsy_doc/DifferentSlider_r75zcr.png" /></p>
    <p>{`Then upload different images for desktop and mobile.`}</p>
    <p>{`Not only images, you can use different settings for desktop and mobile also.`}</p>
    <p>{`Just select `}<inlineCode parentName="p">{`Desktop`}</inlineCode>{` from the dropdown and change settings to apply for desktop only. Similarly, Change the banner config to `}<inlineCode parentName="p">{`mobile`}</inlineCode>{` and change the settings for mobile-only.`}</p>
    <p><img alt="DifferentOption.png" src="https://res.cloudinary.com/redq-inc/image/upload/v1611391416/cartsy_doc/DifferentOption_my2bpn.png" /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      